// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import http from './util/http'
import "./assets/common/public.css"
//移动端适配
// import 'amfe-flexible'
Vue.prototype.$eventBus=new Vue();  //注册eventBus
Vue.config.productionTip = false
// Vue.prototype.$http = http
/* eslint-disable no-new */

//开发环境下加载 vconsole
if (process.env.NODE_ENV === 'development') {
  const VConsole = require('vconsole')
  new VConsole()
}

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  // // 添加mounted，不然不会执行预编译
  // mounted () {
  //   document.dispatchEvent(new Event('render-event'))
  // }
})




// WEBPACK FOOTER //
// ./src/main.js